import { Map } from 'immutable';
import { takeEvery, put, call, select, take } from 'redux-saga/effects';
import { fetchUserDetails } from '../reducers/userDetails';
import { isResidentOnboarding } from './currentProgressOnboardingWizard'
import { namespaceActionObject } from './helpers'
import Auth from '@aws-amplify/auth';

// TYPES
export const REDUCER_ACTIONS = namespaceActionObject('AUTH')({
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  CHECK_SMS_PENDING: 'CHECK_SMS_PENDING',
  CHECK_SMS_ERROR: 'CHECK_SMS_ERROR',
  SMS_CREATION_PENDING: 'SMS_CREATION_PENDING',
  SMS_CREATION_SUCCESS: 'SMS_CREATION_SUCCESS',
  SMS_CREATION_ERROR: 'SMS_CREATION_ERROR',
  LOG_OUT: 'LOG_OUT',
  FIRE_SMS_CREATION: 'FIRE_SMS_CREATION',
  FIRE_SMS_VALIDATION: 'FIRE_SMS_VALIDATION'
})

export const REDUCER_STATUS = {
  LOGGED_OUT: 'LOGGED_OUT',
  SMS_ASKED: 'SMS_ASKED',
  SMS_SENT: 'SMS_SENT',
  SMS_ERROR: 'SMS_ERROR',
  SMS_CHECKING: 'SMS_CHECKING',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGGED_IN: 'LOGGED_IN',
  LOGIN_REQUESTED: 'LOGIN_REQUESTED'
};

// ACTIONS
export const logginSuccess = (token) => ({
  type: REDUCER_ACTIONS.LOGIN_SUCCESS,
  payload: token
});

export const logginRequest = (token) => ({
  type: REDUCER_ACTIONS.LOGIN_REQUEST,
  payload: token
});

export const checkSmsPending = () => ({
  type: REDUCER_ACTIONS.CHECK_SMS_PENDING
});

export const checkSmsError = () => ({
  type: REDUCER_ACTIONS.CHECK_SMS_ERROR
});

export const smsCreationPending = (phone) => ({
  type: REDUCER_ACTIONS.SMS_CREATION_PENDING,
  payload: phone
});

export const smsCreationSuccess = () => ({
  type: REDUCER_ACTIONS.SMS_CREATION_SUCCESS
});

export const smsCreationError = (error) => ({
  type: REDUCER_ACTIONS.SMS_CREATION_ERROR,
  payload: error
});

export const logout = () => ({
  type: REDUCER_ACTIONS.LOG_OUT
});

export const fireSmsCreation = (phone) => {
  return ({
    type: REDUCER_ACTIONS.FIRE_SMS_CREATION,
    payload: phone
  })
};

export const fireSmsValidation = (phone, smsCode) => {
  return ({
    type: REDUCER_ACTIONS.FIRE_SMS_VALIDATION,
    payload: { phone, smsCode }
  })
};

// SAGAS

export function* watchFireSmsCreation() {
  yield takeEvery(REDUCER_ACTIONS.FIRE_SMS_CREATION, fireSmsCreationSaga)
}

export function* watchLoginRequested() {
  yield takeEvery(REDUCER_ACTIONS.LOGIN_REQUEST, handleLoginRequestd)

}

export function* fireSmsCreationSaga(action) {
  const challengeType = 'SMS'
  const { payload: phoneNumber } = action;
  yield put(smsCreationPending(phoneNumber))
  try {
    let firstChar = phoneNumber.substring(0, 1);
    let phone
    if (firstChar === '0') {
      phone = `+972${phoneNumber.slice(1)}`
    } else {
      phone = phoneNumber
    }
    let user = yield call((...params) => Auth.signIn(...params), phone);
    const clientMetadata = {
      flow: challengeType
    };
    if (user.challengeParam.challengeType === 'CHOOSE_CHALLENGE') {
      user = yield call(
        (...params) => {
          return Auth.sendCustomChallengeAnswer(...params);
        },
        user,
        challengeType,
        clientMetadata
      );
    }
    yield put(smsCreationSuccess());
    while (true) {
      try {
        const action = yield take([REDUCER_ACTIONS.FIRE_SMS_VALIDATION])
        yield put(checkSmsPending())
        const smsCode = action.payload.smsCode;
        const updatedUser = yield call(
          (...params) => {
            return Auth.sendCustomChallengeAnswer(...params);
          },
          user,
          smsCode,
          clientMetadata
        );
        const jwtToken = updatedUser.signInUserSession.idToken.jwtToken
        yield put(logginSuccess(jwtToken));
        yield put(fetchUserDetails())
      } catch (error) {
        console.warn("Failed while validating the sms for validation", error);
        yield put(smsCreationError(error));
      }
    }
  } catch (error) {
    console.warn("Failed while creating the sms for validation", error);
    yield put(smsCreationError(error));
  }
}

export function* handleLoginRequestd(props) {
  const reisdentFlow = yield select(isResidentOnboarding);
  if (reisdentFlow && props.payload) {
    yield put(logginSuccess(props.payload));
    yield put(fetchUserDetails());
  }
}

// STATE MAPPERS
export const getAuthToken = (state) => state.auth.get('token');
export const getPhone = (state) => state.auth.get('phone');
export const isLoggedIn = (state) => state.auth.get('status') === REDUCER_STATUS.LOGGED_IN;
export const isSmsCreated = (state) => state.auth.get('status') === REDUCER_STATUS.SMS_SENT;
export const didSmsCreationFailed = (state) => state.auth.get('status') === REDUCER_STATUS.SMS_ERROR;
export const isSmsPending = (state) => state.auth.get("status") === REDUCER_STATUS.SMS_ASKED;
export const isSmsChecking = (state) => state.auth.get("status") === REDUCER_STATUS.SMS_CHECKING;


const initialState = Map({
  status: REDUCER_STATUS.LOGGED_OUT
})

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REDUCER_ACTIONS.SMS_CREATION_PENDING:
      return state.merge({ status: REDUCER_STATUS.SMS_ASKED, phone: payload });
    case REDUCER_ACTIONS.SMS_CREATION_SUCCESS:
      return state.set('status', REDUCER_STATUS.SMS_SENT)
    case REDUCER_ACTIONS.SMS_CREATION_ERROR:
      return state.merge({ status: REDUCER_STATUS.SMS_ERROR, error: payload })
    case REDUCER_ACTIONS.CHECK_SMS_PENDING:
      return state.set('status', REDUCER_STATUS.SMS_CHECKING)
    case REDUCER_ACTIONS.LOGIN_REQUEST:
      return state.merge({ status: REDUCER_STATUS.LOGIN_REQUESTED, token: payload })
    case REDUCER_ACTIONS.LOGIN_SUCCESS:
      return state.merge({ status: REDUCER_STATUS.LOGGED_IN, token: payload });
    case REDUCER_ACTIONS.LOG_OUT:
      return initialState
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js